import React from 'react'

function SoftwareServiceDetails() {
  return (
    <div>
      <div className="services-details-area default-padding">
        <div className="cotnainer">
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <div className="site-heading text-center">
                <h4 className="sub-title">Application Development</h4>
                <h2 className="title">Application Developments for Modern Businesses</h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="services-details-items">
            <div className="row">
              <div className="col-xl-12 services-single-content">
                <div className="thumb mb-50">
                  <img src="static/img/custom/21.jpg" alt="Thumb" />
                </div>
                <p>
                  At Microcode Software, we specialize in providing the latest application development services customized to meet the unique requirements of your business. As one of the best app development companies, we ensure that our clients will get the best services from your side. Our years of experience as a leading mobile app development company guarantee exceptional results, whether you want to start an enterprise, highly responsive mobile applications or customized web app development. Our expert team of web app developers contributes to performing a result-oriented and customer-centric approach in your business application development that gives your business a competitive edge.
                </p>
                <div className="process-style-one-items mt-50">
                  <div className="choose-us-one-thumb">
                    <div className="content">
                      <div className="left-info">
                        <h2 className="title">
                          Smart Ideas, Seamless Code, Strong Results
                        </h2>
                      </div>
                      <div className="process-style-one">
                        <div className="process-style-one-item">
                          <span>01</span>
                          <h4>Ideation & Strategy</h4>
                          <p>
                            Understand business goals, define requirements, and create a strategic roadmap.
                          </p>
                        </div>
                        <div className="process-style-one-item">
                          <span>02</span>
                          <h4>Design & Development</h4>
                          <p>
                            Build scalable, high-performing applications using the latest technologies.
                          </p>
                        </div>
                        <div className="process-style-one-item">
                          <span>03</span>
                          <h4>Testing & Deployment</h4>
                          <p>
                            Ensure quality, security, and performance before launching the application successfully.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default SoftwareServiceDetails
